import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./components/Login/Login";
import Main from "./Main";
import "./App.css";
import Signup from "./components/Signup/Signup";
import { Toaster } from 'react-hot-toast';
import { DeclarationBreadcrumbProvider } from "./contexts/DeclarationBreadcrumbContext";

function App() {
  const [isDarkMode, setIsDarkMode] = useState(
    localStorage.getItem("isDarkMode") || false
  );

  // Disable developer tools on mount useEffect(() => { disableDevTools(); }, []);

  console.log("Patch update: May 18 4:59PM , 2026");

  const [email, setEmail] = useState(sessionStorage.getItem('email') || '');
  const [password, setPassword] = useState('');

  return (
    <Router>
      <Toaster 
        position="bottom-center"
        containerStyle={{
          zIndex: 99999
        }}
      />
      <Routes>
        <Route path="/login" element={<Login isDarkMode={isDarkMode} email={email} password={password} setEmail={setEmail} setPassword={setPassword} />} />
        <Route path="/signup" element={<Signup isDarkMode={isDarkMode} />} />
        <Route
          path="/*"
          element={
            <DeclarationBreadcrumbProvider>
              <Main isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode} email={email} />
            </DeclarationBreadcrumbProvider>
          }
        >
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
